export default "__VITE_ASSET__BLXv8_q2__"